"use strict";
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.blocksApproval = exports.getReviewDecisionEffectiveStatus = void 0;
/**
 * Resolves export-gate status from reviewer counts and optional admin force-approve.
 *
 * This is the single source of truth for the review status, used both for the
 * per-object status computed in memory and for the interview-level status
 * aggregated by the database for the admin interview list.
 * @param approvalCount - Number of approve decisions
 * @param rejectionCount - Number of reject decisions
 * @param isForceApproved - Whether an admin force-approved the object
 * @returns Effective review status for the object
 */
const getReviewDecisionEffectiveStatus = (approvalCount, rejectionCount, isForceApproved) => {
    if (isForceApproved) {
        return 'forceApproved';
    }
    if (approvalCount > 0 && rejectionCount > 0) {
        return 'conflict';
    }
    if (approvalCount > 0) {
        return 'approved';
    }
    if (rejectionCount > 0) {
        return 'rejected';
    }
    return 'notReviewed';
};
exports.getReviewDecisionEffectiveStatus = getReviewDecisionEffectiveStatus;
/**
 * Whether a status stands in the way of approving an object.
 * Approving or rejecting an object is not refused because of another object. The admin UI
 * hides the approve control when a parent is rejected.
 * @param effectiveStatus - Effective review status of the object
 * @returns True when the status must be settled before a force approve makes sense
 */
const blocksApproval = (effectiveStatus) => effectiveStatus === 'rejected' || effectiveStatus === 'conflict';
exports.blocksApproval = blocksApproval;
//# sourceMappingURL=reviewDecisionStatus.js.map